export default __webpack_public_path__ + "static/media/Canach Brassards.2a9813ee.jpg";